import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyApduDQyJ6zktLS3a5sQXmWzruNZFJRdRQ",
  authDomain: "easy-skill-payroll.firebaseapp.com",
  projectId: "easy-skill-payroll",
  storageBucket: "easy-skill-payroll.firebasestorage.app",
  messagingSenderId: "1041515076411",
  appId: "1:1041515076411:web:8b30c18a36a7fdcb87f51e",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
